export const endorsementKeyMap: {
  [key: string]: {[key: string]: string};
} = {
  date: {
    closeDate: 'Close Date',
    cancelDate: 'Cancel Date',
    effectiveDate: 'Effective Date',
    expirationDate: 'Expiration Date',
    originalInceptionDate: 'Original Inception Date'
  },
  fee: {
    premium: 'Premium',
    agencyFee: 'Agency Fee',
    carrierPolicyFee: 'Carrier Policy Fee',
    inspectionFee: 'Inspection Fee',
    stampingFee: 'Stamping Fee',
    taxesFee: 'Taxes and other Fees',
    brokerFee: 'Broker Fee',
    totalProjectedPremium: 'Total Amount'
  },
  object: {
    book: 'Book',
    account: 'Account',
    primaryContact: 'Primary Contact',
    source: 'Source',
    carrier: 'Carrier',
    carrierProduct: 'Insurance Product',
    insuranceQuote: 'Insurance Quote',
    recordType: 'Record Type',
    generalAgent: 'General Agent'
  },
  bool: {
    nonRenew: 'Non-renew'
  },
  other: {
    policyName: 'Policy Name',
    policyNumber: 'Policy Number',
    term: 'Term',
    federalEmployerIdNumber: 'Federal Employer ID Number',
    closed: 'Closed',
    nonRenew: 'Non-renew',
    installmentPlan: 'Installment Plan',
    totalProjectedCommission: 'Total Project Commission',
    type: 'Type',
    productCommissionOverride: 'Commission'
  }
}
